/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractDto } from '../models/ContractDto';
import type { CreateContractDto } from '../models/CreateContractDto';
import type { PaginatedContractListDto } from '../models/PaginatedContractListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ContractsService {
  /**
   * 계약서 생성하기
   * @returns ContractDto
   * @throws ApiError
   */
  public static contractControllerCreateContract({
    requestBody,
  }: {
    requestBody: CreateContractDto;
  }): CancelablePromise<ContractDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/contracts',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 내 계약서 목록 가져오기
   * @returns PaginatedContractListDto
   * @throws ApiError
   */
  public static contractControllerGetMyContract({
    page,
    itemsPerPage,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedContractListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/contracts/me',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 계약서 상세 가져오기
   * @returns ContractDto
   * @throws ApiError
   */
  public static contractControllerGetContract({
    id,
  }: {
    id: number;
  }): CancelablePromise<ContractDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/contracts/{id}',
      path: {
        id: id,
      },
    });
  }
}
